<template>
    <div>
      <b-card :class="['manage-link-card', hasPaddingTop ? 'paddingTop' : '', ]">
          <div slot="header">
              <strong>{{ title }}</strong>
          </div>
          <p v-if="description">
            {{ description }}
          </p>
          <p v-if="!dealershipLink">
              {{ descriptor ? descriptor : title }} are not linked to any account.
          </p>
          <p v-else>
              {{ descriptor ? descriptor : title }} were linked to "{{ dealershipLink.PublisherPartnerName }} - {{ dealershipLink.PublisherDealershipName }}" settings on {{ new Date(dealershipLink.CreatedTS).toLocaleDateString('en-US') }} 
          </p>
          <p :class="['manage-link', 'blue', hasPaddingTop ? 'manage-link-with-margin-top' : 'manage-link-with-margin-auto', ]" @click="OnManageLinkClick">
              Manage {{ descriptor ? descriptor : title }} Link
              <i v-if="!isManageLinkActive" class="fa fa-angle-down fa-2x"></i> 
              <i v-else class="fa fa-angle-up fa-2x"></i>
          </p>
          <div v-if="isManageLinkActive">
            <div v-if="!dealershipLink">
              You can select an account to link the {{ descriptor ? descriptor : title }} to.
              <b-card class="available-links">
                <div slot="header">
                    <strong class="blue">Available Links:</strong>
                </div>
                <!-- link options -->
                <b-form-radio-group v-model="selectedLink">
                  <b-form-radio v-for="(item, index) in dealershipsByCurrentPhysicalDealershipKey" :key="index" name="selectedLink" :value="item">{{ item.PartnerName }} - {{ item.DealershipName }}</b-form-radio>
                </b-form-radio-group>
              </b-card>
              <div class="link-container">
                <span class="cancel-btn" @click="OnCancelLinkClick">Cancel</span>
                <span :class="['link-btn', selectedLink == null ? 'disabled-btn' : '', ]" @click="OnOpenLinkConfirmModal">Link Settings</span>
              </div>
            </div>
            <div class="unlink-container" v-else>
                <span class="unlink-btn" @click="$refs['unlinkConfirmModal'].show()">Unlink {{ descriptor ? descriptor : title }} </span>
            </div>
          </div>
      </b-card>
      <!-- Confirm link modal -->
      <b-modal id="confirm-link-modal" title="Confirm Link" ref="linkConfirmModal" hide-footer>
        <div v-if="selectedLink">
          <p>
            Linking the {{ descriptor ? descriptor : title }} to "{{ selectedLink.PartnerName }} - {{ selectedLink.DealershipName }}'s" {{ descriptor ? descriptor : title }} will modify the settings to match "{{ selectedLink.PartnerName }} - {{ selectedLink.DealershipName }}'s" 
            {{ descriptor ? descriptor : title }}'s Settings. 
          </p>
          <p>
            If "{{ selectedLink.PartnerName }} - {{ selectedLink.DealershipName }}" makes any changes to their {{ descriptor ? descriptor : title }} , those changes will also be reflected in the {{ descriptor ? descriptor : title }}.
          </p>
          <p class="bold">
            You will not be able to modify these settings unless you unlink it from {{ selectedLink.PartnerName }} - {{ selectedLink.DealershipName }}'s settings.
          </p>
          <p>
            Would you like to link the settings?
          </p>
        </div>
        <div>
        <label>
          <input type="checkbox" v-model="isConfirmOverrideSettings">
          I confirm that I understand these settings will be overridden by this action and cannot be reverted to their previous state.
          <span class="checkmark"></span>
        </label>
        </div>
        <div class="modal-btn-container">
          <div class="modal-link-btn" block :class="[isConfirmOverrideSettings ? '' : 'disabled']" @click="OnConfirmLinkClick">Yes, Link The Settings.</div>
          <div class="modal-cancel-btn" block @click="$refs['linkConfirmModal'].hide()">No, Do Not Link The Settings.</div>
        </div>
      </b-modal>
      <!-- Confirm unlink modal -->
      <b-modal id="confirm-unlink-modal" title="Confirm Unlink" ref="unlinkConfirmModal" hide-footer>
        <div v-if="dealershipLink">
          <p>
            Unlinking the {{ descriptor ? descriptor : title }} to "{{ dealershipLink.PublisherPartnerName }} - {{ dealershipLink.PublisherDealershipName }}'s" Quoting 
            Rules settings will allow you to modify and manage these 
            settings.
          </p>
          <p class="bold">
            Any changes that "{{ dealershipLink.PublisherPartnerName }} - {{ dealershipLink.PublisherDealershipName }}" makes to their {{ descriptor ? descriptor : title }} will longer be reflected in these {{ descriptor ? descriptor : title }}.
          </p>
          <p>
            Would you like to unlink the settings?
          </p>
        </div>
        <div class="modal-btn-container">
          <div class="modal-unlink-btn" block @click="OnConfirmUnLinkClick">Yes, Unlink The Settings.</div>
          <div class="modal-cancel-btn" block @click="$refs['unlinkConfirmModal'].hide()">No, Do Not Unlink The Settings.</div>
        </div>
      </b-modal>
    </div>
</template>

<script>
import axios from 'axios'
import DealershipLinkSubscriptionType from '../../enums/DealershipLinkSubscriptionType'

export default {
  props: {
    title: String,
    description: String,
    descriptor: String,
    hasPaddingTop: Boolean,
    accountNumber: String,
    physicalDealershipKey: String,
    dealershipId: Number,
    dealershipLink: Object,
    dealershipsByCurrentPhysicalDealershipKey: Array,
    manageDealershipLinkSubscriptionType: DealershipLinkSubscriptionType
  },
  data () {
    return {
      isManageLinkActive: false,
      isConfirmOverrideSettings: false,
      availableLinks: [],
      selectedLink: null
    }
  },
  created () {

  },
  methods: {
    OnOpenLinkConfirmModal () {
      this.isConfirmOverrideSettings = false
      this.$refs['linkConfirmModal'].show()
    },
    OnManageLinkClick () {
      this.isManageLinkActive = !this.isManageLinkActive
    },
    OnCancelLinkClick () {
      this.isManageLinkActive = false
      this.selectedLink = null
    },
    async OnConfirmLinkClick () {
      let dealershipLinkCreateUpdateRequest = {
        'SubscriberDealershipId': this.dealershipId,
        'PublisherDealershipId': this.selectedLink.DealershipId,
        'LinkType': this.manageDealershipLinkSubscriptionType,
        'IsActive': true
      }

      await axios.post('/api/accounts/dealershiplinkcreateupdate', dealershipLinkCreateUpdateRequest)
      this.$emit('refreshData')
      this.$refs['linkConfirmModal'].hide()
    },
    async OnConfirmUnLinkClick () {
      let dealershipUnlinkCreateUpdateRequest = {
        'SubscriberDealershipId': this.dealershipId,
        'PublisherDealershipId': this.dealershipLink.PublisherDealershipId,
        'LinkType': this.manageDealershipLinkSubscriptionType,
        'IsActive': false
      }

      await axios.post('/api/accounts/dealershiplinkcreateupdate', dealershipUnlinkCreateUpdateRequest)
      this.$emit('refreshData')
      this.$refs['unlinkConfirmModal'].hide()
    }
  },
  computed: {
    DealershipLinkSubscriptionType: () => DealershipLinkSubscriptionType
  }
}
</script>

<style>
  .blue {
    color: #0060A8;
  }
  .bold {
    font-weight: bold;
  }
  .manage-link-card .card {
    margin-bottom: initial;
  }
  .manage-link-card .card-body {
    display: flex;
    flex-direction: column;
  }
  .manage-link-card.paddingTop > .card-body {
    padding-top: 2rem;
  }
  .manage-link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
  }
  .manage-link-with-margin-auto {
    margin-top: auto;
  }
  .manage-link-with-margin-top {
    margin-top: 68px;
  }
  .manage-link-sections .custom-control-inline {
    margin-right: 2rem !important;
  }
  .card-body .card {
    margin-top: 12px;
  }
  .available-links .card-body {
    height: 220px;
    overflow-y: scroll;
    overflow-x: hidden;
  }
  .custom-radio {
    padding-bottom: 1rem;
  }
  .link-container {
    display: flex;
    justify-content: end;
  }
  .link-container span {
    margin-top: 20px;
    padding: 8px 20px;
    border: 1px solid;
  }
  .cancel-btn {
    font-size: 0.875rem;
    background-color: white;
    border-color: #0060A8;
    color: #0060A8;
    border-radius: 4px;
    margin-right: 12px;
    cursor: pointer;
  }
  .link-btn {
    font-size: 0.875rem;
    background-color: #0060A8;
    border-color: #0060A8;
    color: white;
    border-radius: 4px;
    cursor: pointer;
  }
  .unlink-container {
    border: 1px solid;
    border-radius: 4px;
    border-color: #0060A8;
    display: flex;
    justify-content: center;
    padding: 5px;
  }
  .unlink-btn{
    font-size: 0.875rem;
    background-color: white;
    color: #0060A8;
    cursor: pointer;
  }
  .disabled-btn {
    background: #5C95C0;
    color: #dddddd;
    pointer-events: none;
  }
  .disabled {
    opacity: 0.2;
    pointer-events: none;
  }
  .modal-header {
    background-color: #F5F5F5;
    font-weight: bold;
    font-size: 1.25rem;
    color: #004477;
  }
  .modal-title {
    font-weight: bold;
  }
  .modal-body {
    font-size: 0.875rem;
    font-weight: 500;
    color: #212529;
  }
  .modal-btn-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 16px;
  }
  .modal-btn-container .modal-link-btn,
  .modal-btn-container .modal-unlink-btn {
    font-size: 0.875rem;
    background-color: #0060A8;
    border-color: #0060A8;
    color: white;
    padding: 8px 40px;
    cursor: pointer;
  }
  .modal-btn-container .modal-cancel-btn {
    padding-top: 10px;
    font-size:0.875rem;
    color: #0060A8;
    text-decoration: underline;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Account/AccountManageLinkItem.vue